import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { translateMessage } from "@/i18n";

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        aria-label={translateMessage("auth.session.checking")}
        className="flex h-64 items-center justify-center"
        role="status"
      >
        <div
          aria-hidden="true"
          className="h-12 w-12 animate-spin rounded-full border-2 border-line border-r-accent border-t-accent motion-reduce:animate-none"
        />
        <span className="sr-only">{translateMessage("auth.session.checking")}</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
